<template>
    <div class="full-width q-pb-md">
        <q-tabs v-model="event_tab" class="full-width">
            <q-tab
                v-for="(event, index) in event_dates"
                :key="`t${index}`"
                slot="title"
                :name="`${index}`"
                :label="fDateTime(event.hr_start)"
                />

            <q-tab-pane
                v-for="(event, index) in event_dates"
                :key="`tp${index}`"
                :name="`${index}`">

                <q-card class="bg-grey-1 q-mt-xs q-mx-md q-mb-md"
                    v-if="(event_dates.length && event.event_date_type === 1 && event.has_test !== 3) || (event_dates.length && event.event_date_type === 1 && event.has_test === 3 && !event.tests.length)">
                    <q-card-main class="relative-position">
                        <div class="line-card bg-primary absolute-top"></div>

                        <div class="row gutter-xs q-pl-md">
                            <div class="col-12">
                                <p class="q-my-xs text-weight-bolder">{{ $t('presential_event') }}</p>
                            </div>
                            <div class="col-12">
                                <p class="q-my-xs text-weight-bold">{{ $t('instructors') }}</p>
                                <div class="q-my-sm" v-for="(instructor, index) in course.instructors_list" :key="index">
                                    <p class="q-my-xs">{{ instructor.name}}</p>
                                </div>
                            </div>
                            <div class="col-12">
                                <p class="q-my-xs text-weight-bold">{{ $t('event_date') }}</p>
                                <div class="col-4">
                                    <span>{{ $t('start_hour') }}: </span><span>{{ fDateTime(event.hr_start) }}H</span>
                                </div>
                                <div>
                                    <span>{{ $t('end_hour') }}: </span><span>{{ fDateTime(event.hr_end) }}H</span>
                                </div>
                            </div>
                            <div class="col-12 q-my-xs">
                                <p class="q-my-xs text-weight-bold">{{ $t('address') }}</p>
                                <div>
                                    <span class="text-body2">{{ address.address }}, {{ address.number }} - {{ address.neighborhood }}</span>
                                </div>
                                <div>
                                    <span class="text-body2">{{ address.city }} - {{ address.state }}</span>
                                </div>
                            </div>
                        </div>
                    </q-card-main>
                </q-card>

                <q-card class="bg-grey-1 q-mt-xs q-mx-md q-mb-md" v-if="event_dates.length && event.activities.length !== 0 && event.event_date_type === 1 && $q.platform.is.desktop">
                    <q-card-main class="relative-position">
                        <div class="line-card bg-primary absolute-top"></div>
                        <div class="row gutter-xs q-pl-md" v-if="event_dates.length && event.event_date_type === 1" >
                            <div class="col-12">
                                <p class="q-my-xs text-weight-bolder">{{ $t('presential_event') }}</p>
                            </div>
                            <div class="col-12">
                                <p class="q-my-xs text-weight-bold">{{ $t('instructor') }}</p>
                                <p class="q-my-xs">{{ course.instructor_full_name }} - {{ course.instructor_email }}</p>
                            </div>
                            <div class="col-12">
                                <p class="q-my-xs text-weight-bold">{{ $t('event_date') }}</p>
                                <div class="col-4">
                                    <span>{{ $t('start_hour') }}: </span><span>{{ fDateTime(event.hr_start) }}H</span>
                                </div>
                                <div>
                                    <span>{{ $t('end_hour') }}: </span><span>{{ fDateTime(event.hr_end) }}H</span>
                                </div>
                            </div>
                            <div class="col-12 q-mt-xs q-mb-md">
                                <p class="q-my-xs text-weight-bold">{{ $t('address') }}</p>
                                <div>
                                    <span class="text-body1">{{ address.address }}, {{ address.number }} - {{ address.neighborhood }}</span>
                                </div>
                                <div>
                                    <span class="text-body1">{{ address.city }} - {{ address.state }}</span>
                                </div>
                            </div>
                        </div>
                    </q-card-main>
                </q-card>

                <q-table
                    ref="table"
                    :pagination.sync="server_pagination"
                    :data="event_dates[event_tab].activities"
                    :columns="columns"
                    :loading="loading"
                    row-key="id"
                    :no-data-label="$t('no_data_avaliable')"
                    :no-results-label="$t('no_results_found')"
                    :loading-label="$t('loading_data')"
                    :rows-per-page-label="$t('items_per_page')"
                    :rows-per-page-options="[0]"
                    hide-bottom
                    class="shadow-0"
                    v-if="event_dates.length && event.activities.length !== 0 && $q.platform.is.desktop"
                    >

                    <q-tr slot="header" slot-scope="props" :props="props">
                        <q-th v-for="col in props.cols" :key="col.name" :props="props">
                        {{ $t(col.label) }}
                        </q-th>
                    </q-tr>

                    <template slot="body" slot-scope="props">
                        <q-tr :props="props" @click.native="showModal(props.row)" :class="getRowClass(props.row)">
                            <q-td key="type_title" :props="props">
                                {{ props.row.type_title }}
                            </q-td>

                            <q-td key="type_slug" :props="props">
                                <q-icon :name="getIcon(props.row.type_slug)" size="1rem" class="q-mr-sm" />
                                {{ $t(getType(props.row.type_slug)) }}
                            </q-td>

                            <q-td key="avaliable_in" :props="props">
                                {{ fDate(props.row.avaliable_in) }}
                            </q-td>

                            <q-td key="score" :props="props">
                                {{ props.row.score > 0 ? props.row.score : '' }}
                            </q-td>

                            <q-td key="user_watch" :props="props" auto-width>
                                <q-icon name="fas fa-ban" size="1.5rem" color="negative" v-if="props.row.is_blocked" />
                                <q-icon name="far fa-clock" size="1.5rem" color="negative" v-else-if="props.row.is_expired" />
                                <q-icon name="far fa-check-circle" size="1.5rem" color="positive" v-else-if="props.row.user_watch || props.row.is_approved" />
                                <q-icon name="far fa-circle" size="1.5rem" color="primary" v-else />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </q-tab-pane>
        </q-tabs>

        <div v-if="event_dates.length && event_dates[event_tab].activities !== undefined && event_dates[event_tab].activities.length !== 0 && $q.platform.is.mobile">

            <q-card class="bg-grey-1 q-mt-xs q-mx-md q-mb-md" v-if="event_dates.length && event_dates[event_tab].event_date_type !== undefined && event_dates[event_tab].event_date_type === 1 && $q.platform.is.mobile">
                    <q-card-main class="relative-position">
                        <div class="line-card bg-primary absolute-top"></div>
                        <div class="row gutter-xs q-pl-md">
                            <div class="col-12">
                                <p class="q-my-xs text-weight-bolder">{{ $t('presential_event') }}</p>
                            </div>
                            <div class="col-12">
                                <p class="q-my-xs text-weight-bold">{{ $t('instructor') }}</p>
                                <p class="q-my-xs">{{ course.instructor_full_name }} - {{ course.instructor_email }}</p>
                            </div>
                            <div class="col-12">
                                <p class="q-my-xs text-weight-bold">{{ $t('event_date') }}</p>
                                <div class="col-4">
                                    <span>{{ $t('start_hour') }}: </span><span>{{ fDateTime(event_dates[event_tab].hr_start) }}H</span>
                                </div>
                                <div>
                                    <span>{{ $t('end_hour') }}: </span><span>{{ fDateTime(event_dates[event_tab].hr_end) }}H</span>
                                </div>
                            </div>
                            <div class="col-12 q-mt-xs q-mb-md">
                                <p class="q-my-xs text-weight-bold">{{ $t('address') }}</p>
                                <div>
                                    <span class="text-body1">{{ address.address }}, {{ address.number }} - {{ address.neighborhood }}</span>
                                </div>
                                <div>
                                    <span class="text-body1">{{ address.city }} - {{ address.state }}</span>
                                </div>
                            </div>
                        </div>
                    </q-card-main>
                </q-card>

            <q-card class="bg-grey-1 q-mt-md" v-for="(activity, index) in event_dates[event_tab].activities" :key="index" :class="getRowClass(activity)">
                <q-card-main class="relative-position" @click.native="showModal(activity)">
                    <div class="line-card bg-primary absolute-top"></div>

                    <div class="row gutter-sm vertical-middle">
                        <div class="col-9">
                            <p>
                                <q-icon name="fas fa-ban" size="1rem" color="negative" v-if="activity.is_blocked" />
                                <q-icon name="far fa-check-circle" size="1rem" color="positive" v-else-if="activity.user_watch || activity.is_approved" />
                                <q-icon name="far fa-circle" size="1rem" color="primary" v-else />
                                <span class="q-ml-sm q-subheading">{{ activity.type_title }}</span>
                            </p>

                            <div v-if="activity.avaliable_in">
                                <p class="q-caption">{{ $t('avaliable_in') }} {{ fDate(activity.avaliable_in) }}</p>
                            </div>
                        </div>

                        <div class="col-3 text-right">
                            <q-icon :name="getIcon(activity.type_slug)" size="3rem" color="secondary" />
                        </div>
                    </div>
                </q-card-main>

                <q-card-separator v-if="$q.platform.is.android" />
            </q-card>
        </div>

        <q-card class="bg-grey-1 cursor-pointer" v-if="event_dates.length && event_dates[event_tab].activities.length == 0 && event_dates[event_tab].event_date_type !== 1">
            <q-card-main class="relative-position">
                <div class="line-card bg-primary absolute-top"></div>

                <div class="row gutter-sm">
                    <div class="col-12">
                        <p class="q-subheading">{{ $t('no_items_found') }}</p>
                    </div>
                </div>
            </q-card-main>
        </q-card>

        <q-modal v-model="show_modal" :content-css="{minWidth: '100vw', minHeight: '100vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar :style="{display: display}" slot="header">
                    <q-btn flat round dense @click="shouldHideModal()" icon="fas fa-times" v-if="type !== 'block_general_test' && type !== 'restart_general_test'" />
                    <q-toolbar-title>
                        {{ title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">

                    <live-class v-if="in_live_class" :activity="activity" :presential_event_id="id_course" :event_date_id="event_dates[event_tab].id" :closing="closing" :key="id" @closeModal="closeModal" />

                    <webcast v-if="in_webcast" :activity="activity" :presential_event_id="id_course" :event_date_id="event_dates[event_tab].id" :closing="closing" :key="id" @closeModal="closeModal" />

                    <course-test :activity="activity" :event_id="event_dates[event_tab].id" :closing="closing" v-if="type == 'restart_test' || type == 'block_test' || type == 'conventional_test' || type == 'evaluated_quiz' || type == 'unevaluated_quiz'" :key="id" @clearTest="closeModal()" />

                    <course-general-test :activity="activity" :event_id="event_dates[event_tab].id" v-if="type === 'block_general_test' || type === 'restart_general_test'" :key="id" @closeTest="closeModal" />
                </div>
            </q-modal-layout>
        </q-modal>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CourseTest from 'components/presential_viewer/activities/ActivityTest'
import CourseGeneralTest from 'components/presential_viewer/activities/ActivityGeneralTest'
import { date } from 'quasar'
const { formatDate, getDateDiff } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import { db } from 'plugins/vuefire'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'

export default {
    props: ['course', 'address', 'user_subscribed'],

    data() {
        return {
            // Event tab
            event_dates: [],
            event_tab: '0',
            active_tab: 0,
            firebase_activity_id: null,
            firebase_activity_status: 0,
            firebase_activity_db: null,
            firebase_activity_data: null,
            first_load: false,
            in_live_class: false,
            in_webcast: false,
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            },
            columns: [
                {
                    name: 'type_title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'type_title',
                    sortable: false,
                },
                {
                    name: 'type_slug',
                    required: true,
                    label: 'type_activity',
                    align: 'left',
                    field: 'type_slug',
                    sortable: false,
                },
                {
                    name: 'avaliable_in',
                    required: true,
                    label: 'avaliable_in',
                    align: 'left',
                    field: 'avaliable_in',
                    sortable: false,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    sortable: false,
                },
                {
                    name: 'user_watch',
                    required: true,
                    label: 'status',
                    align: 'center',
                    field: 'user_watch',
                    sortable: false,
                }
            ],
            activities: [],
            title: '',
            resource: '',
            id: '',
            type: '',
            activity: [],
            show_modal: false,
            closing: false,
            loading: false,
            activity_selected: [],
            display: 'flex',
            id_course : '',
        }
    },

    components: {
        'live-class': () => import('components/presential_viewer/activities/ActivityLiveClass'),
        'webcast': () => import('components/presential_viewer/activities/ActivityWebcast'),
        'course-test': CourseTest,
        'course-general-test': CourseGeneralTest,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        requestEvents({ pagination }) {
            this.loading = true
            this.event_dates = []
            this.selected_server_pagination = pagination
            this.$q.loading.show()

            let url = `/etraining_presential/presential/${this.id_course}/get_presential_activities/`

            this.$axios.get(url, this.getHeader)
            .then(response => {
                this.event_dates = response.data.map(e => {
                    return {
                        id: e.event_date_id,
                        event_date_type: e.presential_event_date_type,
                        type_activity: e.presential_event_date_type === 1
                            ? 'presential_event' : e.presential_event_date_type === 2
                            ? 'webcast' : 'live_class',
                        timezone: e.timezone,
                        event_date: moment(e.event_date).tz(e.timezone).format('YYYY-MM-DD'),
                        hr_end: moment(e.hr_end).tz(e.timezone).format('YYYY-MM-DDTHH:mm:ss.SSS'),
                        hr_start: moment(e.hr_start).tz(e.timezone).format('YYYY-MM-DDTHH:mm:ss.SSS'),
                        has_test: e.has_test,
                        minimum_score_approval: e.minimum_score_approval,
                        qty_questions: e.qty_questions,
                        tests: e.tests !== undefined && e.tests.length ? e.tests : [],
                        webcast: e.webcast,
                        live_class: e.live_class,
                        activities:
                            e.webcast && e.webcast.tests.length
                            ? [ e.webcast, ...e.webcast.tests.map(t =>
                                ({ ...t, type_id: t.event_date_test_id, type_activity: t.type_slug.includes('quiz')
                                    ? 'quiz' : 'test'
                                }))]
                            : e.webcast && !e.webcast.tests.length === 0
                            ? [ e.webcast]
                            : e.live_class && e.live_class.tests.length
                            ? [e.live_class, ...e.live_class.tests.map(t =>
                                ({ ...t, type_id: t.event_date_test_id, type_activity: t.type_slug.includes('quiz')
                                    ? 'quiz' : 'test'
                                }))]
                            : e.live_class && !e.live_class.tests.length
                            ? [e.live_class]
                            : !e.live_class && !e.webcast && e.tests.length
                            ? [...e.tests.map(t =>
                                ({ ...t, type_id: t.event_date_test_id, type_activity: t.type_slug.includes('quiz')
                                    ? 'quiz' : 'test'
                                }))]
                            : []
                    }
                })

                this.changeActivityDefaults()

                if (this.active_tab) this.event_tab = this.active_tab
                if (this.first_load) {
                    this.setFirebaseActivityData()
                    this.first_load = false
                }

                if (this.event_dates && this.event_dates.length > 1) {
                    let dateNow = new Date()
                    dateNow = moment(dateNow).format('YYYY-MM-DD')
                    let eventToday = this.event_dates.find(d => d.event_date === dateNow)
                    if (eventToday) {
                        this.event_tab = this.event_dates.indexOf(eventToday).toString()
                    }
                }


                this.loading = false
                this.$q.loading.hide()

                this.$emit('reloadActivity')
            })
            .catch(e => {
                this.loading = false
                if (this.$q.platform.is.mobile) this.$q.loading.hide()
                console.log(e)
            })
        },

        changeActivityDefaults() {
           this.event_dates.map(e => {
               if (e.webcast) {
                   let web = e.webcast
                   web.type_slug = 'webcast'
                   web.type_title = web.title
                   web.type_activity = 'webcast'
                   web.type_id = web.webcast_id
                   web.avaliable_in = e.hr_start
                   e.activities[0] = web
               }
               if (e.live_class) {
                   let live = e.live_class
                   live.type_slug = 'live_class'
                   live.type_title = live.title
                   live.type_activity = 'live_class'
                   live.type_id = live.live_class_id
                   live.avaliable_in = e.hr_start
                   e.activities[0] = live
               }
           })
        },

        getType(slug) {
            switch(slug) {
                case 'webcast': return 'webcast'
                break
                case 'live_class': return 'live_class'
                break
                case 'conventional_test': return 'conventional_test'
                break
                case 'block_test': return 'block_test'
                break
                case 'restart_test': return 'restart_test'
                break
                case 'evaluated_quiz': return 'evaluated_quiz'
                break
                case 'unevaluated_quiz': return 'unevaluated_quiz'
                break
                case 'block_general_test': return 'block_general_test'
                break
                case 'restart_general_test': return 'restart_general_test'
                break
            }
        },

        getIcon(slug) {
            switch(slug) {
                case 'webcast': return 'fas fa-broadcast-tower'
                break
                case 'live_class': return 'fas fa-chalkboard-teacher'
                break
                case 'conventional_test':
                case 'restart_test':
                case 'restart_general_test':
                case 'block_general_test':
                case 'block_test': return 'fas fa-check-double'
                break
                case 'evaluated_quiz':
                case 'unevaluated_quiz': return 'far fa-check-square'
                break
            }
        },

        showModal(activity) {
            if ((this.course.status === 6 && activity.type_slug != 'webcast') || (this.course.status === 8 && activity.type_slug != 'webcast')) {
                this.$q.notify({
                    message: this.$t('training_already_ended'),
                    type: 'negative',
                    icon: 'fas fa-ban'
                })
                return
            }

            if (activity.avaliable_in) {
                let date1 = moment(activity.avaliable_in).tz(this.event_dates[this.event_tab].timezone).format('YYYY-MM-DDTHH:mm:ss.SSS')
                let date2 = new Date()
                let unit = 'days'

                let diff = date.getDateDiff(date1, date2, unit)
                if(activity.type_slug === 'live_class') {
                    if (diff !== 0) {
                        this.$q.notify({
                            message: this.$t('live_class_not_available'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })
                        return
                    }
                } else {
                    if (diff > 0) return false
                }
            }

            if (!this.user_subscribed) {
                this.$q.notify({
                    message: this.$t('you_must_subscribe_for_event'),
                    type: 'negative',
                    icon: 'fas fa-ban'
                })
                return
            } else if(activity.allowed_to_test === false) {
                this.$q.notify({
                    message: this.$t('test_not_available_please_wait'),
                    type: 'negative',
                    icon: 'fas fa-ban'
                })
                return
            } else {

                if(activity.type_slug !== 'live_class' && activity.type_slug !== 'webcast' && !activity.allowed_to_test) return

                this.title = activity.type_title
                this.activity = activity
                this.id = activity.type_id
                this.type = activity.type_slug

                this.active_tab = this.event_tab

                if (activity.type_slug === 'live_class') {
                    if (activity.platform_type === 1) {
                        this.in_live_class = true
                        this.setFirebaseActivityData()
                    } else {
                        this.in_live_class = true
                    }
                }

                if (activity.type_slug === 'webcast') {
                    this.in_webcast = true
                    this.setFirebaseActivityData()
                }

                this.resource = activity.resource
                this.show_modal = true
            }
        },

        shouldHideModal() {
            let close_array = ['linkedin_slidshare', 'html', 'scorm', 'evaluated_quiz', 'unevaluated_quiz', 'ppt', 'webcast', 'live_class']

            if (close_array.includes(this.type)) this.closeModal()
            else this.closing = true
        },

        closeModal() {
            this.title = ''
            this.resource = ''
            this.activity = ''
            this.id = ''
            this.type = ''

            this.closing = false
            this.show_modal = false
            this.in_live_class = false
            this.in_webcast = false
            this.requestEvents({ pagination: this.server_pagination })
        },

        getRowClass(activity) {
            if (activity.avaliable_in) {
                let date1 = moment(activity.avaliable_in).tz(this.event_dates[this.event_tab].timezone).format('YYYY-MM-DDTHH:mm:ss.SSS')
                let date2 = new Date()
                let unit = 'days'

                let diff = date.getDateDiff(date1, date2, unit)
                if(activity.type_slug === 'live_class') {
                    if (diff !== 0) return 'blocked-activity text-faded'
                } else {
                    if (diff > 0) return 'blocked-activity text-faded'
                }
            }

            if (!this.user_subscribed || (this.course.status === 6 && activity.type_slug != 'webcast') || (this.course.status === 8 && activity.type_slug != 'webcast')) {
                return 'blocked-activity text-faded'
            } else {
                if (activity.type_slug !== 'live_class' && activity.type_slug !== 'webcast') {
                    if (activity.allowed_to_test) return 'cursor-pointer'
                    else return 'blocked-activity text-faded'
                } else return 'cursor-pointer'
            }
        },

        getButtonLabel(activity) {
            if (activity.is_offline) return 'avaliable_offline'
            else return 'download'
        },

        getActivityCollor(activity) {
            if (activity.is_offline) return 'positive'
            else return ''
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY'
                    break
                    default: format = 'MM-DD-YYYY'
                    break
                }

                return moment(d).tz(this.event_dates[this.event_tab].timezone).format(format)
            }
        },

        fDateTime(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY - HH:mm'
                    break
                    default: format = 'MM-DD-YYYY - HH:mm'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        setFirebaseActivityData() {
            let activity = this.event_dates[this.event_tab].activities[0]
            if (!activity) {
                return
            } else {
                if (activity.type_slug === 'live_class') {
                    this.firebase_activity_db = 'live_class'
                    this.firebase_activity_id = activity.type_id
                } else if (activity.type_slug === 'webcast') {
                    this.firebase_activity_db = 'webcast'
                    this.firebase_activity_id = activity.type_id
                }

                if (activity.type_slug === 'live_class' || activity.type_slug === 'webcast') {
                    this.$bind('firebase_activity_data', db.collection(this.firebase_activity_db).doc(`${this.firebase_activity_id}`))
                    .then(data => {
                        this.firebase_activity_data = data
                    })
                }
            } return
        }
    },

    created() {
        this.id_course = this.$route.params.id
        this.first_load = true

        this.requestEvents({ pagination: this.server_pagination })
    },

    watch: {
        course: function() {
            this.server_pagination = {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            }

            this.id_course = this.$route.params.id
            this.requestEvents({ pagination: this.server_pagination })
        },

        event_tab: function() {
            this.setFirebaseActivityData()
        },

        firebase_activity_data: {
                deep: true,

                handler(){
                    if (this.event_dates && this.event_dates.length) {
                        if (this.event_dates && this.event_dates[this.event_tab].activities !== undefined) {
                            if (this.firebase_activity_data.s === 7 || this.firebase_activity_data.s === 8) {
                                if (this.event_dates[this.event_tab].activities) {
                                    let activity = this.event_dates[this.event_tab].activities.find(a => a.tests)
                                    if (activity.tests && activity.tests.length) {
                                        activity.tests[0].allowed_to_test === false
                                        ? this.requestEvents({ pagination: this.server_pagination })
                                        : null
                                    }
                                }
                            }
                        }
                    } else return
                }
        }
    }
}
</script>

<style lang="stylus" scoped>
.blocked-activity
    cursor not-allowed

.line-card
    border-top: 3px solid transparent
    border-top-left-radius inherit
    border-top-right-radius inherit
</style>
